import JsonLd from "@/components/base/JsonLd";
import SeoHead from "@/components/feature/SeoHead";
import Hero from "@/pages/home/components/Hero";
import HotTicker from "@/pages/home/components/HotTicker";
import CategorySection from "@/pages/home/components/CategorySection";
import FeedSection from "@/pages/home/components/FeedSection";
import TrendingSection from "@/pages/home/components/TrendingSection";
import StatsSection from "@/pages/home/components/StatsSection";
import FaqSection from "@/pages/home/components/FaqSection";
import SubmitBand from "@/pages/home/components/SubmitBand";
import { siteInfo } from "@/mocks/site";
import { tips } from "@/mocks/tips";
import type { Tip } from "@/types/content";

const tipList: Tip[] = tips;

export default function Home() {
  const origin = typeof window !== "undefined" ? window.location.origin : "";
  const latest = tipList.slice(0, 6);
  const trending = [...tipList].sort((a, b) => b.views - a.views).slice(0, 5);

  const schema = [
    {
      "@context": "https://schema.org",
      "@type": "Organization",
      name: siteInfo.name,
      description: siteInfo.description,
      email: siteInfo.email,
      url: origin,
    },
    {
      "@context": "https://schema.org",
      "@type": "WebSite",
      name: siteInfo.name,
      description: siteInfo.description,
      url: origin,
      potentialAction: {
        "@type": "SearchAction",
        target: `${origin}/feed?q={search_term_string}`,
        "query-input": "required name=search_term_string",
      },
    },
  ];

  return (
    <>
      <SeoHead
        title="爆料专区 - 匿名爆料与热点线索社区"
        description="爆料专区是支持匿名投稿的社区平台，提供爆料投稿、私信通道、评论区互动留言。分享身边的新鲜事与独家线索，参与热议，让你的声音被更多人看到。"
        keywords="爆料专区,爆料投稿,匿名爆料,热点线索,评论区互动,私信通道"
        path="/"
      />
      <JsonLd data={schema} />

      <Hero />
      <HotTicker list={tipList.slice(0, 6)} />
      <CategorySection />
      <FeedSection list={latest} />
      <TrendingSection list={trending} />
      <StatsSection />
      <FaqSection />
      <SubmitBand />
    </>
  );
}